import React from "react";
import { Row, Col } from "react-bootstrap";
import { useIntl, FormattedMessage } from "react-intl";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";

import Button from "components/atoms/Button/Button";
import Dialog from "components/organisms/Dialog/Dialog";

const QuoteExtensionDialog = function ({
  quoteExtensionDialog,
  closeQuoteExtensionModal,
  submitQuoteExtension,
  errorMessage,
  isRequestingExtension,
}) {
  const intl = useIntl();
  const methods = useForm();
  const { handleSubmit } = methods;

  return (
    <Dialog
      id="quotation_extension_confirmation"
      show={quoteExtensionDialog}
      title={intl.formatMessage({
        id: "quote-request.quotationExtension",
        defaultMessage: "Quotation extension",
      })}
      // onHide={false}
      centered
      size="md"
    >
      <form onSubmit={handleSubmit(submitQuoteExtension)}>
        <Row className="mb-3">
          <Col className="pb-3">
            {errorMessage ? (
              <div className="text-danger">{errorMessage.replace(/^"(.*)"$/, "$1")}</div>
            ) : (
              <div>
                <FormattedMessage
                  id="quote-request.quotationExtensionMessage"
                  defaultMessage="Are you sure you want to request an extension for this quotation?"
                />
              </div>
            )}
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <div className="d-block border-grey border-top w-100" />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col lg={12}>
            {errorMessage && (
              <Button
                size="lg"
                className="btn-grey w-100"
                label={intl.formatMessage({
                  id: "components.organisms.dialog.close",
                  defaultMessage: "Close",
                })}
                onClick={() => closeQuoteExtensionModal()}
              />
            )}

            {!errorMessage && (
              <Row>
                <Col lg={6} className="pr-lg-1 mb-sm-2">
                  <Button
                    size="lg"
                    className="w-100"
                    label={intl.formatMessage({
                      id: "general.no",
                      defaultMessage: "No",
                    })}
                    variant="light"
                    onClick={() => closeQuoteExtensionModal()}
                  />
                </Col>
                <Col lg={6} className="pl-lg-1">
                  <Button
                    size="lg"
                    className="w-100"
                    variant="success"
                    label={intl.formatMessage({
                      id: "quote-request.quotationExtensionSubmit",
                      defaultMessage: "Yes",
                    })}
                    type="submit"
                    disabled={isRequestingExtension}
                  />
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </form>
    </Dialog>
  );
};

QuoteExtensionDialog.propTypes = {
  quoteExtensionDialog: PropTypes.bool.isRequired,
  closeQuoteExtensionModal: PropTypes.func.isRequired,
  submitQuoteExtension: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  isRequestingExtension: PropTypes.bool.isRequired,
};

QuoteExtensionDialog.defaultProps = {
  errorMessage: null,
};

export default QuoteExtensionDialog;
